import { Box } from "@mui/material";
import styled from "styled-components";

interface DisplaySidebarProps {
  displaysidebar: boolean;
}

// Children Component
export const Children = styled.div<DisplaySidebarProps>`
  width: 100%;
  height: 100%;
  margin-left: ${({ displaysidebar }) => (displaysidebar ? "15rem" : "15rem")};

  @media (max-width: 468px) {
    margin-left: 5rem;
  }
`;

export const SidebarWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
`;

export const SidebarLogoWrapper = styled.div<DisplaySidebarProps>`
  padding: 0.5rem 0.1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: ${({ displaysidebar }) =>
    displaysidebar ? "space-around" : "center"};
  align-items: center;

  @media (max-width: 468px) {
    justify-content: center;
  }
`;

export const SidebarLogo = styled.a`
  display: flex;
  align-items: center;

  @media (max-width: 468px) {
    display: none;
  }
`;

export const SidebarBrand = styled.span<DisplaySidebarProps>`
  display: ${({ displaysidebar }) => (displaysidebar ? "block" : "none")};
`;

export const SidebarToggler = styled.button<DisplaySidebarProps>`
  cursor: pointer;
  display: ${({ displaysidebar }) => (displaysidebar ? "block" : "none")};

  @media (max-width: 468px) {
    display: block;
  }
`;

// SidebarItem styles
export const ItemsList = styled.ul`
  list-style: none;
`;

export const ItemContainer = styled.li`
  margin-top: 0.5rem;
  width: 100%;
  padding: 0rem 0.15rem;
  border-radius: 0.2rem;
  cursor: pointer;

  &:hover {
    background: #eaeced;
  }

  &.active {
    background-color: #dbe4f3;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #7c7788;

   svg {
    font-size: 18px;
  }
`;

export const ItemName = styled.span<DisplaySidebarProps>`
  margin-left: ${({ displaysidebar }) => (displaysidebar ? "0.5rem" : "0")};
  display: ${({ displaysidebar }) => (displaysidebar ? "block" : "none")};
  text-transform: capitalize;
`;

// Sidebar Container
export const SidebarContainer = styled.div<DisplaySidebarProps>`
  position: absolute;

  background: #f3f4f4;
  transition: width 0.3s ease-in-out;
  border-right: 1px solid #d4d8dd;
  overflow-x: hidden;
  ${({ displaysidebar }) =>
    displaysidebar && "box-shadow: 8px 0px 12px 0px rgba(0,0,0,0.1)"};

  ${ItemWrapper} {
    justify-content: ${({ displaysidebar }) => !displaysidebar && "center"};
  }

  &:hover {
    ${({ displaysidebar }) =>
    !displaysidebar && "box-shadow: 8px 0px 12px 0px rgba(0,0,0,0.1)"};

    @media (min-width: 468px) {
      width: ${({ displaysidebar }) => !displaysidebar && "15rem"};

      ${SidebarLogoWrapper} {
        justify-content: ${({ displaysidebar }) =>
    !displaysidebar && "space-around"};
      }

      ${SidebarBrand} {
        display: ${({ displaysidebar }) => !displaysidebar && "block"};
      }

      ${SidebarToggler} {
        display: ${({ displaysidebar }) => !displaysidebar && "block"};
      }

      ${ItemWrapper} {
        justify-content: ${({ displaysidebar }) =>
    !displaysidebar && "flex-start"};
      }

      ${ItemName} {
        display: ${({ displaysidebar }) => !displaysidebar && "block"};
        margin-left: ${({ displaysidebar }) => !displaysidebar && "0.5rem"};
      }
    }
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 3px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #eaeced;

    &:hover {
      background: #d5e0f3;
    }
  }

  @media (max-width: 468px) {
    width: 5rem;
  }
`;

export const GridTable = styled(Box) <DisplaySidebarProps>`
  flexGrow: 1;
  margin:  ${({ displaysidebar }) => (displaysidebar ? "75px 0px 75px 240px" : "75px 0px 75px 100px")};
  overflow: 'auto';
  height: 'auto';
  width: 'auto';
`;
export const GridTable1 = styled(Box) <DisplaySidebarProps>`
  flex-grow: 1;
  margin: ${({ displaysidebar }) =>
    displaysidebar ? "75px 0px 75px 240px" : "75px 0px 75px 100px"};
  
  height: 100vh;
  width: 100vw;
   display: flex;
  flex-direction: column;
`;